import { UseFormRegister } from 'react-hook-form';
import cslx from 'clsx';
import { IFormInput, SingleDetail } from '../types';

interface InputFieldProps {
  register: UseFormRegister<IFormInput>;
  item: SingleDetail;
  errors: Record<string, any>;
  inputHandler: (key: string, value: string) => void;
  formValues: IFormInput;
  t: (key: string) => string;
}

export default function InputField(props: InputFieldProps) {
  const { inputHandler, item, errors, register, formValues, t } = props;
  const { id, required } = item;

  const value =
    formValues[item['id' as keyof SingleDetail] as keyof IFormInput];

  const camelToUnderscore = (str: string) => {
    return str.replace(/([A-Z])/g, '_$1').toLowerCase();
  };

  return (
    <div className="w-full">
      <label className="text-gray-700 mb-0-5 block text-1-2">
        {t(`create_user_modal.${camelToUnderscore(id)}`)}
      </label>
      <input
        {...register(id as keyof IFormInput, { required: required })}
        className={cslx(
          errors[id] ? 'border-red' : 'border-grey-200',
          'mb-0 block w-full appearance-none rounded-4-0 border  bg-grey-100 bg-opacity-50 p-1-0 text-1-6 leading-1-0 text-grey-800 focus:bg-white focus:outline-none',
        )}
        type={item.type || 'text'}
        placeholder={t(`create_user_modal.${camelToUnderscore(id)}`) as string}
        name={id}
        value={value as string | number}
        onChange={(e) => inputHandler(id, e.target.value)}
      />
      {errors[id] && (
        <p className="absolute text-1-2 italic text-red">
          {t(`create_user_modal.${camelToUnderscore(id)}`)}{' '}
          {t('global.is_required')}
        </p>
      )}
    </div>
  );
}
